module.exports = __webpack_public_path__ + "static/media/reason_setup.68529665.svg";